export const BUSINESS_CATEGORIES = [
  { label: "Professional Services", icon: "🏢", types: [
    { value: "accounting", label: "Accounting / CPA" }, { value: "lawyer", label: "Law Firm" },
    { value: "insurance_agency", label: "Insurance Agency" }, { value: "real_estate_agency", label: "Real Estate" },
    { value: "finance", label: "Finance / Investment" }, { value: "consultant", label: "Consultant" },
  ]},
  { label: "Health & Medical", icon: "🏥", types: [
    { value: "doctor", label: "Doctor" }, { value: "dentist", label: "Dentist" },
    { value: "hospital", label: "Hospital / Clinic" }, { value: "pharmacy", label: "Pharmacy" },
    { value: "physiotherapist", label: "Physiotherapist" }, { value: "veterinary_care", label: "Veterinary" },
  ]},
  { label: "Food & Hospitality", icon: "🍽️", types: [
    { value: "restaurant", label: "Restaurant" }, { value: "cafe", label: "Café" },
    { value: "bar", label: "Bar / Pub" }, { value: "bakery", label: "Bakery" },
    { value: "hotel", label: "Hotel" }, { value: "food", label: "Food Business" },
  ]},
  { label: "Retail & Shopping", icon: "🛒", types: [
    { value: "store", label: "Retail Store" }, { value: "clothing_store", label: "Clothing" },
    { value: "electronics_store", label: "Electronics" }, { value: "furniture_store", label: "Furniture" },
    { value: "jewelry_store", label: "Jewelry" }, { value: "shopping_mall", label: "Mall" },
  ]},
  { label: "Home & Trade", icon: "🔧", types: [
    { value: "electrician", label: "Electrician" }, { value: "plumber", label: "Plumber" },
    { value: "roofing_contractor", label: "Roofing" }, { value: "general_contractor", label: "Contractor" },
    { value: "moving_company", label: "Moving" }, { value: "locksmith", label: "Locksmith" },
  ]},
  { label: "Beauty & Wellness", icon: "💄", types: [
    { value: "beauty_salon", label: "Beauty Salon" }, { value: "hair_care", label: "Hair Salon" },
    { value: "spa", label: "Spa / Wellness" }, { value: "gym", label: "Gym" },
    { value: "nail_salon", label: "Nail Salon" }, { value: "massage", label: "Massage" },
  ]},
  { label: "Education", icon: "🎓", types: [
    { value: "school", label: "School" }, { value: "university", label: "University" },
    { value: "driving_school", label: "Driving School" }, { value: "library", label: "Library" },
  ]},
  { label: "Automotive", icon: "🚗", types: [
    { value: "car_dealer", label: "Car Dealer" }, { value: "car_repair", label: "Auto Repair" },
    { value: "car_wash", label: "Car Wash" }, { value: "gas_station", label: "Gas Station" },
  ]},
  { label: "Technology", icon: "💻", types: [
    { value: "electronics_store", label: "Tech Store" }, { value: "computer_store", label: "Computer Store" },
  ]},
];

export const RADIUS_OPTIONS = [
  { value: 500, label: "500m" }, { value: 1000, label: "1km" }, { value: 2000, label: "2km" },
  { value: 5000, label: "5km" }, { value: 10000, label: "10km" }, { value: 20000, label: "20km" },
  { value: 50000, label: "50km" },
];

export const SORT_OPTIONS = [
  { value: "lead_score", label: "Lead Score" }, { value: "rating_desc", label: "Rating ↓" },
  { value: "reviews_desc", label: "Most Reviews" }, { value: "name", label: "Name A–Z" },
];

export const PLAN_COLORS = { free: "gray", pro: "blue", enterprise: "purple" };
export const STATUS_COLORS = { active: "green", inactive: "yellow", suspended: "red" };
export const LEAD_STATUS_COLORS = { new: "blue", contacted: "yellow", qualified: "purple", converted: "green", lost: "red" };
export const PRIORITY_COLORS = { low: "gray", medium: "blue", high: "orange", urgent: "red" };
